import { render, staticRenderFns } from "./RoleManagementModal.vue?vue&type=template&id=1820282d&"
import script from "./RoleManagementModal.vue?vue&type=script&lang=js&"
export * from "./RoleManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports